var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgCodeBg(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 150,
    height: 50,
    viewBox: "0 0 150 50",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M0 4C0 1.79086 1.79086 0 4 0H146C148.209 0 150 1.79086 150 4V15C144.477 15 140 19.4772 140 25C140 30.5228 144.477 35 150 35V46C150 48.2091 148.209 50 146 50H4C1.79086 50 0 48.2091 0 46V35C5.52285 35 10 30.5228 10 25C10 19.4772 5.52285 15 0 15V4Z",
    fill: "#E8EBFF"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCodeBg);
export default __webpack_public_path__ + "static/media/code_bg.304bc87b56ecd1e661b6a35cca65db9d.svg";
export { ForwardRef as ReactComponent };